<template>
  <div class="main">
    <div class="title-layout">
      <div class="title">{{ title }}</div>
      <div class="close-btn"> X</div>
      <div class="cross-line"></div>
    </div>
    <clouded-glass :hidden-array="['top','bottom','left','right']" class="top device-info">
      <div slot="content" class="pb-4">
        <div class="alarm-color"></div>
        <div class="name row pt-2 pl-5 mt-2">
          <div class="col-md-12">{{ deviceName }}</div>
        </div>
        <div class="alarm text-center py-1 col-md-10">暂无告警</div>
        <div class="row pl-5">
          <div class="col-md-3">类型：{{}}</div>
          <div class="col-md-3">品牌：{{}}</div>
          <div class="col-md-3">型号：{{}}</div>
        </div>
      </div>
    </clouded-glass>
    <div class="device-info center">
      <slot name="content"></slot>
    </div>
  </div>
</template>

<script>
import CloudedGlass from "@/components/style/CloudedGlass";

export default {
  name: "BaseLayout",
  components: {CloudedGlass},
  props: {
    title: {
      type: String,
      default: () => '设备详情'
    },
    deviceName: {
      type: String,
      default: () => 'UPS'
    }
  },
  data() {
    return {}
  }
}
</script>

<style scoped>
.main {
  overflow: auto;
}

.title-layout {
  margin: 30px 20px 0 20px;
}

.title-layout .title {
  float: left;
  width: 56px;
  height: 25px;
  line-height: 25px;
  font-size: 1rem;
  font-weight: bold;
  color: #01EFFD;
}

.title-layout .close-btn {
  float: right;
  text-align: center;
  line-height: 25px;
  color: #FFFFFF;
  width: 60px;
  height: 25px;
  background: rgba(41, 155, 255, .2);
  opacity: 1;
  border-radius: 2px;
  margin-bottom: 5px;
}

.title-layout .close-btn:hover {
  cursor: pointer;
  background: rgba(41, 155, 255, .4);
}

.title-layout .cross-line {
  clear: both;
  width: 100%;
  height: 0;
  border: 1px solid #299BFF;
  opacity: 0.5;
}

.device-info.top {
  margin: 30px 20px 0 20px;
  width: calc(100% - 40px);
  height: 100%;
  border-radius: 2px;
}

.device-info.center {
  margin: 5px 20px 0 20px;
  width: calc(100% - 40px);
  height: 100%;
  border-radius: 2px;
}

.device-info .alarm-color {
  width: 30px;
  height: 2px;
  background: #15DEB5;
  opacity: 1;
}

.device-info .name {
  height: 19px;
  font-size: 1rem;
  font-weight: bold;
  line-height: 19px;
  color: #299BFF;
}
</style>
